export default "__VITE_ASSET__c351411e__"